// extracted by mini-css-extract-plugin
module.exports = {"container":"Verification_container__2p0Zk","status":"Verification_status__3CGYt","field":"Verification_field__2b3As"};